// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const medium = "500";
export const negativeDelta = "NetworthDelta__negativeDelta__iMJuH";
export const positiveDelta = "NetworthDelta__positiveDelta__h2J6m";
export const regular = "400";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";